import { render, staticRenderFns } from "./forms@.vue?vue&type=template&id=04489820&"
import script from "./forms@.vue?vue&type=script&lang=ts&"
export * from "./forms@.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports